export enum UsersOrganizationsPermissionsWriteType {
    IsOwner = 1,
}

// Máximo é Math.pow(2, 31)
